module.exports = __webpack_public_path__ + "/public/images/98b28642485021b6726d18ad86f8388e.gif";